import React from 'react'
import { useDispatch } from 'react-redux'

// @ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import ClientValidationResults from '../shared/Modals/ClientValidationResults/ClientValidationResults'
import { CLIENT_VALIDATION_RESULTS_MODAL, CONFIRM_MATRIX_WARNING } from './constants'
import { getResubmit } from './clientsContainerForm'
import { translateLKMessage } from './translate'

function openConfirmMatrixWarning(sessionId, sessionHash) {
  return LKModalActions.openConfirmation(CONFIRM_MATRIX_WARNING, {
    message: translateLKMessage('CONFIRM_VALIDATION_WARNING_OVERRIDE'),
    sessionId,
    sessionHash,
  })
}

const ClientFormModals = () => {
  const dispatch = useDispatch()

  return (
    <>
      <ClientValidationResults
        //@ts-ignore
        name={CLIENT_VALIDATION_RESULTS_MODAL}
        onClose={({ params: validationParams }) => {
          if (validationParams.askForConfirm) {
            dispatch(openConfirmMatrixWarning(validationParams.sessionId, validationParams.sessionHash))
          }
        }}
      />

      <LKModal.Confirmation
        name={CONFIRM_MATRIX_WARNING}
        onConfirm={(modalParams) => {
          getResubmit()(modalParams.sessionId, modalParams.sessionHash)
        }}
      />
    </>
  )
}

export default ClientFormModals
